module.exports = __webpack_public_path__ + "img/allegro-smart.80c31534.png";